var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu_bar"},[_c('div',{ref:"menuBar",staticClass:"menu_bar_button",on:{"click":_vm.barClick}},[_vm._t("default")],2),_c('div',{ref:"menuBarMenus",staticClass:"drop_down_menus",class:{ show: _vm.menu_show },style:({
      top: _vm.menu_top + 'px',
      right: _vm.menu_right + 'px',
      width: `${_vm.width === 'auto' ? _vm.width : _vm.width + 'px'}`
    })},[_vm._t("menus")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }